<template>
  <div>
    <topbar
      :titulo="$t('SUPRIMENTOS.ESTOQUE')"
      :subtitulo="$t('SUPRIMENTOS.DESCRICAO_TELA')"
      :breadcrumbs="breadcrumbs"
    />

    <!-- filtro tabela -->
    <filtro-estoque
      ref="filtroEstoqueRef"
      @filtro="setFiltro"
      @saida-manual="abrirModal"
      @transferencia="abrirModalTransferencia"
      @ajuste-inventario="abrirModal"
      @filtrar="filtrarEstoque"
      @limpar="limparFiltro"
    />

    <!-- <span v-if="filtrandoPor.depositoId">
      Quantidade total estoque: <span>{{ totalProduto }}</span>
    </span> -->
    <!-- tabela -->
    <b-table
      :fields="fields"
      :items="items"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      responsive
      show-empty
      striped
      hover
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(dataMovimento)="item">
        <span>{{ formatDateToShow(item.item.dataMovimento) }}</span>
      </template>
      <template #cell(quantidade)="item">
        <span
          v-if="item.item.tipoMovimentoEstoque === saida"
          class="text-danger"
          >{{ item.item.quantidade }}</span
        >
        <span v-else class="text-success">{{ item.item.quantidade }}</span>
      </template>
      <template #cell(acoes)="item">
        <b-button
          v-if="item.item.tipoMovimentoEstoque === saida && podeEditar"
          variant="secondary"
          @click="confirmarEstorno(item.item)"
        >
          {{ $t('GERAL.ESTORNAR') }}
        </b-button>
      </template>
    </b-table>

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getEstoques"
    />

    <!-- modais -->
    <modal-saida-manual
      :exibir="modaisVisibilidade.saidaManual"
      :opcoes="opcoes"
      @fechar="() => fecharModal('saidaManual')"
      @saidaManualConcluida="atualizarTabela"
    />
    <modal-ajuste-inventario
      :exibir="modaisVisibilidade.ajusteInventario"
      :opcoes="opcoes"
      @fechar="() => fecharModal('ajusteInventario')"
      @ajusteInventarioConcluido="atualizarTabela"
    />
    <modal-transferencia-deposito
      :exibir="modaisVisibilidade.transferencia"
      :opcoes="opcoes"
      @fechar="() => fecharModal('transferencia')"
      @tranferenciaDepositoConcluída="atualizarTabela"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import breadcrumb from '@/common/utils/breadcrumb';
import mensagem from '@/common/utils/mensagem';
import datas from '@/common/utils/datas';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';
// Service:
import ProdutoService from '@/common/services/produtos/produtos.service';
import DepositoService from '@/common/services/depositos/depositos.service';
import EstoqueMovimentoService from '@/common/services/estoque-movimento/estoque-movimento.service';
import EstoqueService from '@/common/services/estoque/estoque.service';

// Components:
import FiltroEstoque from './components/filtro/Index';
import ModalSaidaManual from './components/modais/saida-manual/Index';
import ModalTransferenciaDeposito from './components/modais/transferencia-deposito/Index';
import ModalAjusteInventario from './components/modais/ajuste-inventario/Index';
import Paginacao from '@/components/paginacao/Paginacao';

import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  mixins: [Permissoes],
  components: {
    FiltroEstoque,
    Paginacao,
    Topbar,
    ModalTransferenciaDeposito,
    ModalSaidaManual,
    ModalAjusteInventario,
  },
  computed: {
    breadcrumbs() {
      return [
        { titulo: 'SUPRIMENTOS.SUPRIMENTOS' },
        { titulo: 'SUPRIMENTOS.ESTOQUE' },
      ];
    },
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: 'SUPRIMENTOS.SUPRIMENTOS' },
      { titulo: 'SUPRIMENTOS.ESTOQUE' },
    ]);
    this.getProdutos();
    this.getDepositos();
    // this.getEstoques();
  },
  data() {
    return {
      items: [],
      saida: 85,
      fields: [
        {
          key: 'depositoDescricao',
          label: this.$t('SUPRIMENTOS.DEPOSITO'),
          sortable: true,
        },
        {
          key: 'dataMovimento',
          label: this.$t('SUPRIMENTOS.DATA'),
          sortable: true,
        },
        {
          key: 'descricaoTipoMovimentoEstoque',
          label: this.$t('SUPRIMENTOS.TIPO_MOVIMENTO'),
          sortable: true,
        },
        {
          key: 'quantidade',
          label: this.$t('SUPRIMENTOS.QUANTIDADE'),
          sortable: true,
        },
        {
          key: 'detalhesMovimento',
          label: this.$t('SUPRIMENTOS.DETALHES_MOVIMENTO'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('SUPRIMENTOS.ACOES'),
        },
      ],
      totalProduto: 0,
      filtrandoPor: {
        depositoId: null,
        produtoId: null,
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      modaisVisibilidade: {
        transferencia: false,
        saidaManual: false,
        ajusteInventario: false,
      },
      opcoes: {
        // produtos: [],
        depositos: [],
      },
      campoOrdenado: 'DataMovimento',
      ordem: true,
    };
  },
  methods: {
    filtrarEstoque() {
      this.paginacao.numeroDaPagina = 0;
      this.getEstoques();
    },
    realizarEstorno(itemId) {
      this.$store.dispatch(START_LOADING);
      EstoqueService.estorno(itemId)
        .then(() => {
          mensagem.sucesso(
            this.$t('GERAL.SUCESSO'),
            this.$t('GERAL.ITEM_ESTORNADO').formatUnicorn({
              item: this.$t('SUPRIMENTOS.ESTOQUE'),
            })
          );
          this.getEstoques();
          this.$refs.filtroEstoqueRef.buscaSaldoTotalEstoque();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    formatDateToShow(date) {
      return datas.formatDateToShow(date);
    },
    
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      this.novaOrdenacao(helpers.primeiraLetraMaiuscula(sortBy), sortDesc);
    },
    getEstoques() {
      this.$store.dispatch(START_LOADING);

      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado: this.campoOrdenado,
        OrdenacaoAscendente: this.ordem,
        ...this.filtrandoPor,
      };
      EstoqueMovimentoService.obterPorFiltro(param)
        .then(({ data }) => {
          this.paginacao.total = data.paginacao.totalDeElementos
          this.items = data.itens;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getProdutos() {
      this.$store.dispatch(START_LOADING);
      ProdutoService.obterTodos()
        .then(({ data }) => {
          this.opcoes.produtos = data.map((prod) => ({
            produtoId: prod.id,
            text: `${prod.codigo} - ${prod.descricao}`,
            value: prod.id,
          }));
        })
        .catch((error) => {
          mensagem.showErrors(error);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getDepositos() {
      this.$store.dispatch(START_LOADING);
      DepositoService.obterTodos()
        .then(({ data }) => {
          this.opcoes.depositos = data.itens.map((deposito) => ({
            depositoNovoId: deposito.id,
            text: deposito.descricao,
            value: deposito.id,
          }));
        })
        .catch((error) => {
          mensagem.showErrors(error)
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // funções tabela
    atualizarTabela() {
      this.$refs.filtroEstoqueRef.buscaSaldoTotalEstoque();
      this.getEstoques();
    },
    // FUNÇÕES MODAL:
    abrirModalTransferencia() {
      this.modaisVisibilidade.transferencia = true;
    },
    abrirModal(modal) {
      this.modaisVisibilidade[modal] = true;
    },

    fecharModal(modal) {
      this.modaisVisibilidade[modal] = false;
    },
    async confirmarEstorno(item) {
      const respostaEstorno = await mensagem.confirmacao(
        this.$t('GERAL.CONFIRMAR_ESTORNO'),
        this.$t('GERAL.CONFIRMAR_ESTORNO_ITEM').formatUnicorn({
          item: `${item.descricao}`,
        })
      );
      respostaEstorno.isConfirmed ? this.realizarEstorno(item.id) : {};
    },

    setFiltro(value) {
      this.filtrandoPor = value;
    },

    limparFiltro() {
      this.items = [];
      this.filtrandoPor = {
        depositoId: null,
        produtoId: null,
      },
      this.paginacao = {
        numeroDaPagina: 1,
        tamanhoDaPagina: 5,
        total: 0,
      }
    },

    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.getEstoques();
    },
  },
};
</script>
